import { DocumentReference } from './document-reference';
import { deserializeData, serializeData } from './utils';
export class FirebaseFirestoreClient {
    constructor(plugin) {
        this.plugin = plugin;
    }
    async addCollectionGroupSnapshotListener(options, callback) {
        return this.plugin.addCollectionGroupSnapshotListener(serializeData(options), (event, error) => {
            if (event) {
                for (const snapshot of event.snapshots) {
                    if (snapshot.data !== null) {
                        snapshot.data = deserializeData(snapshot.data);
                    }
                }
            }
            callback(event, error);
        });
    }
    async addCollectionSnapshotListener(options, callback) {
        return this.plugin.addCollectionSnapshotListener(serializeData(options), (event, error) => {
            if (event) {
                for (const snapshot of event.snapshots) {
                    if (snapshot.data !== null) {
                        snapshot.data = deserializeData(snapshot.data);
                    }
                }
            }
            callback(event, error);
        });
    }
    async addDocument(options) {
        const result = await this.plugin.addDocument(Object.assign(Object.assign({}, options), { data: serializeData(options.data) }));
        result.reference = DocumentReference.fromPath(result.reference.path);
        return result;
    }
    async addDocumentSnapshotListener(options, callback) {
        return this.plugin.addDocumentSnapshotListener(options, (event, error) => {
            if ((event === null || event === void 0 ? void 0 : event.snapshot.data) !== null &&
                (event === null || event === void 0 ? void 0 : event.snapshot.data) !== undefined) {
                event.snapshot.data = deserializeData(event.snapshot.data);
            }
            callback(event, error);
        });
    }
    async clearPersistence() {
        return this.plugin.clearPersistence();
    }
    async deleteDocument(options) {
        return this.plugin.deleteDocument(options);
    }
    async disableNetwork() {
        return this.plugin.disableNetwork();
    }
    async disablePersistence() {
        return this.plugin.disablePersistence();
    }
    async enableNetwork() {
        return this.plugin.enableNetwork();
    }
    async enablePersistence(options) {
        return this.plugin.enablePersistence(options);
    }
    async getCollection(options) {
        const result = await this.plugin.getCollection(serializeData(options));
        for (const snapshot of result.snapshots) {
            if (snapshot.data !== null) {
                snapshot.data = deserializeData(snapshot.data);
            }
        }
        return result;
    }
    async getCollectionGroup(options) {
        const result = await this.plugin.getCollectionGroup(serializeData(options));
        for (const snapshot of result.snapshots) {
            if (snapshot.data !== null) {
                snapshot.data = deserializeData(snapshot.data);
            }
        }
        return result;
    }
    async getCountFromServer(options) {
        return this.plugin.getCountFromServer(options);
    }
    async getDocument(options) {
        const result = await this.plugin.getDocument(options);
        if (result.snapshot.data !== null) {
            result.snapshot.data = deserializeData(result.snapshot.data);
        }
        return result;
    }
    async removeAllListeners() {
        return this.plugin.removeAllListeners();
    }
    async removeSnapshotListener(options) {
        return this.plugin.removeSnapshotListener(options);
    }
    async setDocument(options) {
        return this.plugin.setDocument(Object.assign(Object.assign({}, options), { data: serializeData(options.data) }));
    }
    async updateDocument(options) {
        return this.plugin.updateDocument(Object.assign(Object.assign({}, options), { data: serializeData(options.data) }));
    }
    async useEmulator(options) {
        return this.plugin.useEmulator(options);
    }
    async writeBatch(options) {
        return this.plugin.writeBatch(Object.assign(Object.assign({}, options), { operations: options.operations.map(op => (Object.assign(Object.assign({}, op), { data: op.data ? serializeData(op.data) : op.data }))) }));
    }
}
//# sourceMappingURL=client.js.map